import { render, staticRenderFns } from "./ObservacaoDeClasse.vue?vue&type=template&id=d8c993a8&scoped=true&"
import script from "./ObservacaoDeClasse.vue?vue&type=script&lang=js&"
export * from "./ObservacaoDeClasse.vue?vue&type=script&lang=js&"
import style0 from "./ObservacaoDeClasse.vue?vue&type=style&index=0&id=d8c993a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c993a8",
  null
  
)

export default component.exports